import axiosInstance from "../core/index-core";

class AdminService {
  baseUrl = '/api/admin';

  static getInstance() {
    if (!AdminService._instance) {
      AdminService._instance = new AdminService();
    }
    return AdminService._instance;
  }

  async getUsers({ page = 1, page_size = 50, search, role } = {}) {
    const params = { page, page_size };
    if (search) params.search = search;
    if (role) params.role = role;
    const { data } = await axiosInstance.get(`${this.baseUrl}/users`, { params });
    return data;
  }

  async getDetailsByNpi(npi) {
    const { data } = await axiosInstance.get(`${this.baseUrl}/npi`, {
      params: {
        number: npi
      }
    });
    return data;
  }

  async createUser(payload) {
    const { data } = await axiosInstance.post(
      `${this.baseUrl}/users`,
      payload
    );
    return data;
  }

  async getUserById(userId) {
    const { data } = await axiosInstance.get(
      `${this.baseUrl}/users/${userId}`
    );
    return data;
  }

  async updateUser(userId, payload) {
    const { data } = await axiosInstance.patch(
      `${this.baseUrl}/users/${userId}`,
      payload
    );
    return data;
  }

  async deactivateUser(userId) {
    const { data } = await axiosInstance.delete(
      `${this.baseUrl}/users/${userId}`
    );
    return data;
  }

  async reactivateUser(userId) {
    const { data } = await axiosInstance.post(
      `${this.baseUrl}/users/${userId}/reactivate`
    );
    return data;
  }

  async bulkImportUsers(payload) {
    const { data } = await axiosInstance.post(
      `${this.baseUrl}/users/bulk`,
      payload
    );
    return data;
  }
}

const adminService = AdminService.getInstance();

export default adminService;
